/**
 * Samsung Smart TV (Tizen) bridge.
 * Handles TV remote keys, back button, and platform detection.
 * Only activates when running on a Tizen device.
 */

export const isTizenTV = typeof window !== 'undefined' && !!(window.tizen || navigator.userAgent.includes('Tizen'));

export function initTizenBridge() {
  if (!isTizenTV) return;

  console.log('[Tizen] Samsung Smart TV detected. Initializing bridge...');

  // Register TV remote input keys
  try {
    if (window.tizen && window.tizen.tvinputdevice) {
      const keys = [
        'MediaPlay', 'MediaPause', 'MediaStop', 'MediaPlayPause',
        'MediaRewind', 'MediaFastForward',
        'ColorF0Red', 'ColorF1Green', 'ColorF2Yellow', 'ColorF3Blue',
        'ChannelUp', 'ChannelDown',
      ];
      keys.forEach(key => {
        try { window.tizen.tvinputdevice.registerKey(key); } catch (e) {}
      });
      console.log('[Tizen] Remote keys registered.');
    }
  } catch (e) {
    console.warn('[Tizen] Could not register remote keys:', e);
  }

  // Handle Back button — navigate back or exit app
  document.addEventListener('keydown', (e) => {
    if (e.keyCode === 10009) { // TizenKeyCode.Back
      e.preventDefault();
      if (window.history.length > 1) {
        window.history.back();
      } else {
        // Exit app on back from home screen
        try {
          if (window.tizen && window.tizen.application) {
            window.tizen.application.getCurrentApplication().exit();
          }
        } catch (err) {
          console.warn('[Tizen] Could not exit app:', err);
        }
      }
    }
  });

  // Handle media keys for video playback
  document.addEventListener('keydown', (e) => {
    const video = document.querySelector('video');
    if (!video) return;

    switch (e.keyCode) {
      case 415: // MediaPlay
        video.play();
        break;
      case 19:  // MediaPause
        video.pause();
        break;
      case 413: // MediaStop
        video.pause();
        video.currentTime = 0;
        break;
      case 10252: // MediaPlayPause
        video.paused ? video.play() : video.pause();
        break;
      case 412: // MediaRewind
        video.currentTime = Math.max(0, video.currentTime - 10);
        break;
      case 417: // MediaFastForward
        video.currentTime = Math.min(video.duration, video.currentTime + 10);
        break;
    }
  });

  // Prevent screen from sleeping during video playback
  try {
    if (window.webapis && window.webapis.appcommon) {
      window.webapis.appcommon.setScreenSaver(window.webapis.appcommon.AppCommonScreenSaverState.SCREEN_SAVER_OFF);
    }
  } catch (e) {}

  console.log('[Tizen] Bridge initialized.');
}
